/* eslint-disable object-property-newline */
import { inlineTag } from './tags/inline';
import { htmlEscChart } from './eschars';

export const spLig = /\\(ae|oe|S|V|R)/;
export const spCh = /\\(['"`~^](?:\\ae|\\oe|\w))/;
export const spCh2 = /\\([+=])/;
export const spAmp = /&([#0-9a-zA-Z]+);/;
export const spPunc = /(<<|>>|--)/;
export const quote = /(['"])/;

export function handleSpCh(state, p) {
  if (state.xMode()) return state.log(p.match);

  /* eslint-disable-next-line no-shadow */
  const { spCh, spCh2, spAmp, spPunc, spLig, quote, lb, la } = p;
  if (spCh) state.log(spRepl(spCh));
  else if (spCh2) state.log(spRepl(spCh2));
  else if (spAmp) state.log(htmlRepl(spAmp));
  else if (spPunc) state.log(spRepl(spPunc));
  else if (spLig) {
    // console.log('splig', spLig);
    if (/^[vr]$/i.test(spLig)) {
      inlineTag(state, { itag: '^^', lb: ' ', la: ' ' });
      state.log(spRepl(spLig).toUpperCase() + '.');
      inlineTag(state, { itag: '^^', lb: ' ', la: ' ' });
    } else state.log(spRepl(spLig));
  } else if (quote) state.log(qRepl(quote, lb, la, state));
}

/* eslint-disable-next-line no-shadow */
function spRepl(spCh) {
  if (s[spCh]) return s[spCh];

  const head = spCh[0];
  let tail = spCh.substr(1);
  if (tail[0] === '\\') tail = tail.substr(1);
  const body = s[tail];
  if (body && s[head + body]) return s[head + body];

  let repl = spCh;
  const acc = s[head];
  if (acc) {
    if (body) repl = body + acc;
    else if (tail.length > 1) repl = tail[0] + acc + tail.substr(1);
    else repl = tail + acc;
    // console.log('spRepl, combo', spCh, repl);
  }
  return repl;
}

function htmlRepl(text) {
  let txt2 = text;
  if (txt2[0] === '#') {
    txt2 = parseInt(txt2.substr(1), 16);
  }
  let code = htmlEscChart[txt2];
  if (!code) code = parseInt(txt2);
  if (code > 0) return String.fromCharCode(code);
  else return '&' + txt2 + ';';
}

export function clearQuotes(state) {
  delete state["'"];
  delete state['"'];
}
/* eslint-disable-next-line no-shadow */
function qRepl(quote, lb, la, state) {
  if (state.code) return quote;

  // contraction apostrophe
  if (quote === "'" && w(lb) && w(la)) return s["r'"];
  // plural possessive
  if (quote === "'" && !state[quote] && w(lb) && !w(la)) return s["r'"];

  if (state[quote]) {
    state[quote] = false;
    return s['r' + quote];
  } else {
    state[quote] = true;
    return s['l' + quote];
  }
}
export function w(char) {
  const source = '[' + Object.keys(s)
    .filter(x => x.length > 1 && /\w/.test(x[1]))
    .map(x => s[x]).join('') + 'a-z0-9]';
  const rx = new RegExp(source, 'i');
  const retval = rx.test(char);
  // console.log('w', rx, char, retval);
  return retval;
}

export const s = {
  S: '\u00a7',

  "'a": '\u00e1', "'e": '\u00e9', "'i": '\u00ed', "'o": '\u00f3',
  "'u": '\u00fa', "'y": '\u00fd',
  "'A": '\u00c1', "'E": '\u00c9', "'I": '\u00cd', "'O": '\u00d3',
  "'U": '\u00da', "'Y": '\u00dd',
  /* ae */"'\u00e6": '\u01fd', /* AE */"'\u00c6": '\u01fc',
  /* oe */"'\u0153": '\u0153\u0301', /* OE */"'\u0152": '\u0152\u0301',
  "'": '\u0301',
  ae: '\u00e6', AE: '\u00c6', oe: '\u0153', OE: '\u0152',

  '`': '\u0300',
  '`a': '\u00e0', '`e': '\u00e8', '`i': '\u00ec', '`o': '\u00f2',
  '`u': '\u00f9', '`y': '\u1ef3',
  '`A': '\u00c0', '`E': '\u00c8', '`I': '\u00cc', '`O': '\u00d2',
  '`U': '\u00d9', '`Y': '\u1ef2',

  '^': '\u0302',
  '^a': '\u00e2', '^e': '\u00ea', '^i': '\u00ee', '^o': '\u00f4',
  '^u': '\u00fb', '^y': '\u0177',
  '^A': '\u00c2', '^E': '\u00ca', '^I': '\u00ce', '^O': '\u00d4',
  '^U': '\u00db', '^Y': '\u0176',

  '"': '\u0308',
  '"a': '\u00e4', '"e': '\u00eb', '"i': '\u00ef', '"o': '\u00f6',
  '"u': '\u00fc', '"y': '\u00ff',
  '"A': '\u00c4', '"E': '\u00cb', '"I': '\u00cf', '"O': '\u00d6',
  '"U': '\u00dc', '"Y': '\u0178',

  '~': '\u0303',

  '+': '\u2020', '=': '\u2021',
  '<<': '\u00ab', '>>': '\u00bb',
  '--': '\u2014',
  "l'": '\u2018', "r'": '\u2019',
  'l"': '\u201c', 'r"': '\u201d',

};
